/*
 * Unjellic cart helpers (loaded once on every page from snippets/unjellic-mobile.liquid).
 * Scripts inside the cart drawer / popup HTML do not run when Shopify re-renders them, so the logic lives here and a
 * MutationObserver wires up whatever appears.
 *   1) quantity stepper buttons ( - 1 + )
 *   2) compact "Early delivery by ..." line (same rules as snippets/unjellic-delivery: dispatch from Jaipur)
 */
(function () {
  'use strict';
  if (window.__unjCart) return;
  window.__unjCart = true;

  /* ---------- 1) quantity stepper ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-unj-qty]');
    if (!btn || btn.disabled) return;
    var wrap = btn.closest('[data-unj-qty-wrap]');
    var input = wrap && wrap.querySelector('input.quantity-input');
    if (!input) return;
    var next = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-unj-qty'), 10);
    var max = parseInt(input.getAttribute('max'), 10);
    if (next < 1) return;
    if (max && next > max) return;
    wrap.querySelectorAll('[data-unj-qty]').forEach(function (b) { b.disabled = true; });
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- 2) compact delivery date ---------- */
  var KEY = 'unj_pincode';
  var NEARBY = ['ajmer', 'alwar', 'dausa', 'sikar', 'jhunjhunu', 'tonk', 'bharatpur', 'nagaur', 'sawai madhopur',
    'dholpur', 'karauli', 'churu', 'kota', 'bundi', 'gurugram', 'gurgaon', 'rewari', 'mahendragarh', 'nuh',
    'faridabad', 'palwal'];

  function clean(v) { return (v || '').toLowerCase().trim(); }
  function valid(pin) { return /^[1-9][0-9]{5}$/.test(pin); }

  function addBusinessDays(start, days) {
    var d = new Date(start), n = 0;
    while (n < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) n++;   // Sundays do not count
    }
    return d;
  }

  function fmt(d) {
    return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function earliest(info) {
    var district = clean(info.district), state = clean(info.state);
    var jaipur = district.indexOf('jaipur') !== -1;
    var nearby = NEARBY.indexOf(district) !== -1 || state === 'delhi' || state === 'nct of delhi';
    var total = jaipur ? 2 : 2 + (nearby ? 3 : 4);
    return addBusinessDays(new Date(), total);
  }

  function cached(pin) {
    try { var v = sessionStorage.getItem('unj_dc_' + pin); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }

  function lookup(pin, done, fail) {
    var c = cached(pin);
    if (c) { done(c); return; }
    fetch('https://api.postalpincode.in/pincode/' + pin)
      .then(function (r) { if (!r.ok) throw new Error('net'); return r.json(); })
      .then(function (data) {
        if (!data || !data[0] || data[0].Status !== 'Success' || !data[0].PostOffice || !data[0].PostOffice.length) {
          throw new Error('invalid');
        }
        var o = data[0].PostOffice[0];
        var info = { district: o.District || o.Block || '', state: o.State || '', name: o.District || o.Name || '' };
        try { sessionStorage.setItem('unj_dc_' + pin, JSON.stringify(info)); } catch (e) {}
        done(info);
      })
      .catch(function (err) { fail(err && err.message === 'invalid' ? 'invalid' : 'net'); });
  }

  function initDc(el) {
    if (el.getAttribute('data-dc-bound')) return;
    el.setAttribute('data-dc-bound', '1');

    var result = el.querySelector('[data-dc-result]');
    var dateEl = el.querySelector('[data-dc-date]');
    var cityEl = el.querySelector('[data-dc-city]');
    var form = el.querySelector('[data-dc-form]');
    var input = el.querySelector('[data-dc-input]');
    var go = el.querySelector('[data-dc-go]');
    var error = el.querySelector('[data-dc-error]');
    var note = el.querySelector('[data-dc-note]');
    var change = el.querySelector('[data-dc-change]');
    if (!result || !form || !input) return;

    function showResult(info) {
      dateEl.textContent = fmt(earliest(info));
      cityEl.textContent = info.name ? '· ' + info.name : '';
      result.hidden = false;
      form.hidden = true;
      error.hidden = true;
      if (note) note.hidden = false;
    }

    function showForm(prefill) {
      result.hidden = true;
      form.hidden = false;
      if (note) note.hidden = true;
      if (prefill) input.value = prefill;
    }

    function check() {
      var pin = input.value.replace(/\D/g, '').slice(0, 6);
      input.value = pin;
      error.hidden = true;
      if (!valid(pin)) { error.textContent = 'Please enter a valid 6-digit pincode.'; error.hidden = false; return; }
      go.disabled = true;
      lookup(pin, function (info) {
        go.disabled = false;
        try { localStorage.setItem(KEY, pin); } catch (e) {}
        showResult(info);
      }, function (why) {
        go.disabled = false;
        error.textContent = why === 'invalid' ? 'We could not find this pincode.' : 'Unable to check right now. Please try again.';
        error.hidden = false;
      });
    }

    go.addEventListener('click', check);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
    input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 6); error.hidden = true; });
    if (change) change.addEventListener('click', function () {
      var saved = ''; try { saved = localStorage.getItem(KEY) || ''; } catch (e) {}
      showForm(saved);
      input.focus();
    });

    var saved = '';
    try { saved = localStorage.getItem(KEY) || ''; } catch (e) {}
    if (valid(saved)) {
      var c = cached(saved);
      if (c) { showResult(c); }
      else { showForm(saved); lookup(saved, showResult, function () { showForm(saved); }); }
    } else {
      showForm('');
    }
  }

  function scan() {
    document.querySelectorAll('[data-unj-dc]:not([data-dc-bound])').forEach(initDc);
  }

  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();